module.exports = __webpack_public_path__ + "img/area-3-2.eb22cc8.jpg";